"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInfoAlert = exports.TotalPriceSmall = exports.BoxChosen = exports.ProductNote = exports.TotalPrice = exports.OrderTitle = exports.ProductDescription = exports.ProductTitle = exports.BillingProfilesSelect = void 0;
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
exports.BillingProfilesSelect = (0, styled_components_1.default)(antd_1.Select) `
	width: 100%;
`;
exports.ProductTitle = styled_components_1.default.div `
	font-size: 1.2rem;
	font-weight: bold;
`;
exports.ProductDescription = styled_components_1.default.div `
	font-size: 1rem;
`;
exports.OrderTitle = styled_components_1.default.div `
	font-size: 1.2rem;
	margin-bottom: 0.5rem;
`;
exports.TotalPrice = styled_components_1.default.span `
	margin: 0 0.5rem;
	color: ${props => props.theme.color.success};
`;
exports.ProductNote = styled_components_1.default.div `
	color: ${props => props.theme.color.gray6};
	padding: 1em 0 0 0;
	font-size: 0.9em;
	text-align: center;
`;
exports.BoxChosen = styled_components_1.default.div `
	padding: 0;
	font-size: 1.5em;
	color: ${props => props.theme.color.brand1};
	font-weight: 700;
`;
exports.TotalPriceSmall = styled_components_1.default.small `
	margin-left: 0.5rem;
	padding: 0;
	font-size: 0.7em;
	font-weight: 400;
	color: ${props => props.theme.color.gray6};
`;
exports.StyledInfoAlert = (0, styled_components_1.default)(antd_1.Alert) `
	background-color: #e6f7ff;
	border: 1px solid #91d5ff;
	color: rgba(0, 0, 0, 0.85);
	.anticon {
		color: #1890ff;
	}
`;
